import React, { useState, useEffect } from 'react';
import { Typography, Divider, Modal, Spacer } from '@telus-uds/components-web';
import PropTypes from 'prop-types';
import _ from 'lodash';
import axios from 'axios';
// import OrderSummary from '../../form/orderSummary';
import { Box } from '../../design/css';
import { OrderDetailsBox } from '../../defectManagement/css';
import { OrderSummaryMain } from './css';
import { getLocale } from '../../misc';
import {
  contentfulFormConfig,
  getContentfulData,
  getData
} from '../../contentful';
import {
  orderStatus as statusConstants,
  CONSTANT,
  productValuesToBackendKeys,
  keyOrderSummaryForm,
  keyOrderSummary
} from '../../utils/constant';
import ContractEmails from '../../design/contract-emails';
import EN from '../../../EN.json';
import FR from '../../../FR.json';

import request, { apiHost, config as axiosConfig } from '../../utils/request';
import ViewOrderHeader from './viewOrderHeader';
import {
  OrderHistory,
  Comments,
  OrderButton
} from '../dashboardCommon/components';
import ValidateLoader from '../../UI/validateLoader';
import OrderAction from './components/orderAction';
import Attachements from './components/attachments';
import OrderSummary from '../../form/orderSummary/fmOrderSummary';
import StickyOrderModalHeader from '../dashboardCommon/StickyOrderModalHeader';

const ViewOrder = ({ orderData, open, setOpen, onSave, fetchData }) => {
  const locale = getLocale();
  const config = { ...contentfulFormConfig, locale };
  const { id: orderId, status: orderStatus } = orderData;
  const { incomplete } = statusConstants;
  const {
    KEYS: {
      ROLES: { ADMIN }
    }
  } = CONSTANT;

  const {
    WLS: {
      WIRELESS_ORDER_DETAILS: {
        actions: { confirm }
      }
    },
    ORDERS: { ORDER_SUMMARY, save }
  } = locale === 'en-US' ? EN : FR;

  const { getProfile } = request;
  const profile = getProfile();
  const { role: { name: roleName = 'none' } = {} } = profile || {};

  const [progressBarSteps, setProgressBarSteps] = useState();
  const [comment, setComment] = useState('');
  const [addingComment, setAddingComment] = useState(false);
  const [isOrderValidating, setIsOrderValidating] = useState(false);
  const [loading, setLoading] = useState();
  const [error, setError] = useState();
  const [contractEmailPopUp, setContractEmailPopUp] = useState(false);
  const [actionChanged, setActionChanged] = useState(false);
  const [addNewComment, setAddNewComment] = useState(false);
  const [status, setStatus] = useState(orderStatus || '');
  const [updatedQuote, setUpdatedQuote] = useState('');
  const [isQuoteChanged, setIsQuoteChanged] = useState(false);
  const isStatusChanged =
    status !== orderStatus || status === statusConstants.contractSend;
  const isOrderUpdated = isStatusChanged || comment;

  const canShowUpdatedQuote = (newStatus, newRoleName) => {
    return (
      newRoleName === ADMIN &&
      (newStatus === statusConstants.SendBacktoAccountManager ||
        newStatus === statusConstants.pendingValidation)
    );
  };
  const closeModal = needToClose => {
    if (isOrderUpdated && !error) {
      if (onSave) {
        onSave({ isUpdated: true, orderId: orderData.orderId });
      }
      if (needToClose) setOpen(!open);
    }
  };

  const onAddComment = async () => {
    setAddingComment(true);
    await axios
      .post(
        `${apiHost}/orders/${orderData.id}/comments`,
        { text: comment },
        axiosConfig()
      )
      .catch(() => {})
      .finally(() => {
        setAddingComment(false);
      });
  };

  const onSaveClick = async (needToClose = true) => {
    if (comment) await onAddComment();
    closeModal(needToClose);
  };

  const updateOrder = async ccEmailData => {
    const updateBody = {
      step: status === incomplete ? 1 : undefined
    };

    if (isStatusChanged) updateBody.status = status;
    if (roleName === ADMIN && isQuoteChanged) {
      updateBody.updatedQuote = updatedQuote;
    }
    if (status === statusConstants.contractSend) {
      updateBody.isContractResend = false;
      if (ccEmailData !== null) {
        updateBody.contractEmail = ccEmailData.contractEmail;
        updateBody.contractEmailCC = ccEmailData.contractEmailCC;
      }
    }
    if (status === statusConstants.submitted) {
      updateBody.completedAt = new Date();
    }
    setLoading(true);

    try {
      setLoading(true);
      const response = await request.put(`/orders/${orderData.id}`, updateBody);
      if (comment) {
        await onAddComment();
      }
      await fetchData();
      setIsQuoteChanged(false);
      return response.data;
    } catch (err) {
      throw err;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (orderData && orderData.updatedQuote) {
      setUpdatedQuote(orderData.updatedQuote);
    }
  }, [orderData]);

  const updateProgressBarSteps = (productSelection, steps) => {
    let result = steps.filter(item =>
      [
        'additionalcustomerInformationFM',
        'customerInformationFullyManaged'
      ].includes(item.fields.backendKey)
    );
    if (productSelection && productSelection.length) {
      result = [
        ...result,
        ...steps.filter(stepItem =>
          productSelection.some(
            item =>
              productValuesToBackendKeys[item] === stepItem.fields.backendKey
          )
        )
      ];
    }

    result = [
      ...result,
      ...steps.filter(item =>
        [keyOrderSummaryForm, keyOrderSummary].includes(item.fields.backendKey)
      )
    ];

    setProgressBarSteps(result);
  };

  useEffect(() => {
    getContentfulData(config).then(res => {
      const { formCategories } = getData(res);
      const categoryFM = formCategories.find(
        category => _.get(category, 'fields.name', '') === 'fully managed'
      );

      const fmOrderSummaryFrom = _.get(categoryFM, 'fields.forms', []).find(
        form => _.get(form, 'fields.name', '') === 'Fully Managed Form'
      );

      updateProgressBarSteps(
        orderData.productSelectionFM,
        _.get(fmOrderSummaryFrom, 'fields.steps', [])
      );
    });
  }, []);

  const onClickSave = async (needToClose = true) => {
    if (!isOrderUpdated && !isQuoteChanged) return;
    try {
      setIsOrderValidating(true);
      setLoading(true);
      if (isStatusChanged && status === statusConstants.contractSend) {
        setContractEmailPopUp(true);
      } else {
        await updateOrder();
        if (comment) {
          onAddComment();
        }
        closeModal(needToClose);
      }
      setIsOrderValidating(false);
      setLoading(false);
      setIsQuoteChanged(false);
    } catch (err) {
      setError(err.message);
      setIsOrderValidating(false);
      setLoading(false);
    }
  };

  const button = {
    label: save,
    onClick: onClickSave,
    variant: 'purple'
  };

  const buttonSaveComment = {
    label: save,
    onClick: onSaveClick,
    variant: 'purple'
  };

  const onStatusChange = e => {
    setStatus(e.target.value);
    setActionChanged(true);
  };

  useEffect(() => {
    setError(false);
  }, [status, comment]);

  return (
    <div id="modal">
      {open && <StickyOrderModalHeader />}
      {loading ? (
        <ValidateLoader message="Loading Content" />
      ) : (
        <Modal
          isOpen={open}
          onClose={setOpen}
          heading={orderData.orderId}
          variant={{ width: 'xl' }}
          tokens={{ maxWidth: 1024 }}
        >
          <Spacer space={4} />
          <OrderDetailsBox>
            <ViewOrderHeader orderData={orderData} />
          </OrderDetailsBox>
          <Typography heading="h2" variant={{ size: 'h2' }} block>
            {ORDER_SUMMARY}
          </Typography>
          <Spacer space={2} />
          <OrderSummaryMain>
            <OrderSummary stepData={progressBarSteps} orderData={orderData} />
          </OrderSummaryMain>
          <OrderHistory orderId={orderData.id} />
          <Comments
            comment={comment}
            setComment={setComment}
            orderId={orderData.id}
            activeButton={setAddNewComment}
          />
          <Box
            mt={20}
            display="flex"
            justifyContent="center"
            width="100"
            style={{ alignItems: 'center' }}
          >
            <OrderButton
              button={{ ...buttonSaveComment, label: 'Save' }}
              isOrderValidating={addingComment}
              actionChanged={addNewComment}
            />
          </Box>
          <Attachements orderData={orderData} />
          {canShowUpdatedQuote(status, roleName) && (
            <div style={{ padding: '1rem 0' }}>
              <Typography heading="h3" variant={{ size: 'h5' }} block>
                Update Quote
              </Typography>
              <textarea
                rows={4}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  marginBottom: '10px'
                }}
                value={updatedQuote}
                placeholder="Update quote for this order"
                onChange={e => {
                  setUpdatedQuote(e.target.value);
                  setIsQuoteChanged(true);
                  setActionChanged(true);
                }}
              />
            </div>
          )}
          <Divider space={2} variant={{ inverse: true }} />
          {orderStatus !== statusConstants.submitted && (
            <Typography heading="h2" variant={{ size: 'h4' }} block>
              Select action/status
            </Typography>
          )}
          <ContractEmails
            signingAuthorityEmail={orderData.email_signingAuthority || ''}
            open={contractEmailPopUp}
            setOpen={setContractEmailPopUp}
            error={error}
            setData={async data => {
              try {
                await updateOrder(data);
                setContractEmailPopUp(false);
                closeModal(true);
              } catch (err) {
                if (err.response && err.response.data) {
                  setError(err.response.data.message);
                }
              }
            }}
          />
          {orderStatus !== statusConstants.submitted && (
            <OrderAction
              button={button}
              orderStatus={orderData.status}
              orderId={orderData.id}
              isOrderValidating={isOrderValidating}
              onStatusChange={onStatusChange}
              actionChanged={actionChanged}
              status={status}
              isOrderUpdated={isOrderUpdated}
            />
          )}
        </Modal>
      )}
    </div>
  );
};

ViewOrder.propTypes = {
  orderData: PropTypes.shape({
    orderId: PropTypes.string,
    id: PropTypes.number,
    status: PropTypes.string,
    productSelectionFM: PropTypes.arrayOf(PropTypes.string),
    updatedQuote: PropTypes.string,
    email_signingAuthority: PropTypes.string
  }).isRequired
};
export default ViewOrder;
